import { useRef } from 'react';
function StringToReactComponent(deps, props) {
  var getCtx = deps.getCtx,
    Babel = deps.Babel,
    react = deps.react;
  var ref = useRef(null);
  ref.current = ref.current || getCtx(react, Babel);
  var api = ref.current;
  var babelOptions = props.babelOptions || {};
  var GeneratedComponent = api.updateTemplate(props.children || '', babelOptions).getComponent();
  var data = props.data || {};
  return /*#__PURE__*/React.createElement(GeneratedComponent, data);
}
export default StringToReactComponent;